"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProgressBar = require("./ProgressBar.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * ProgressBar component primarily used to indicate completion % of a given process
 */
// intentionally leaving as a functional component
var ProgressBar = function ProgressBar(_ref) {
  var _inStyleGuide = _ref._inStyleGuide,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      percentComplete = _ref.percentComplete,
      props = _objectWithoutProperties(_ref, ["_inStyleGuide", "className", "dataTestId", "percentComplete"]);

  var displayPercent = percentComplete > 100 ? 100 : percentComplete;
  return /*#__PURE__*/_react.default.createElement(_ProgressBar.StyledProgressBar, _extends({}, props, {
    className: className,
    "data-test-id": dataTestId
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-progress-bar-percent-complete",
    style: {
      width: "".concat(displayPercent, "%")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-progress-bar-percent-label"
  }, displayPercent >= 10 ? "".concat(displayPercent.toFixed(0), "%") : ' ')));
};

ProgressBar.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** percent complete - text displays on the bar once >= 10% */
  percentComplete: _propTypes.default.number,

  /** a flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
};
ProgressBar.defaultProps = {
  className: '',
  percentComplete: '',
  _inStyleGuide: false
};
var _default = ProgressBar;
exports.default = _default;